/*
 * Copyright (c) 2025. Orion Analytics. All Rights Reserved
 */

import React, {useContext, useEffect, useState} from "react";
import Stockchart from "../stockchart_plotly";
import DisplayCards from "../metricCards";
import DynamicStockCharts from "../dynamicStockCharts_plotly";
import FundaTeaser from "../fundamentals/stockFundamentalTeaser";
import Plot from "react-plotly.js";
import {fetchMarketIndices, fetchMarketSentiment, fetchPage} from "../../api";
import MarketBreadth from "./market_breadth";
import SectorPerformance from "./sector_performance";


const Sentiment = ({sentimentData,pcrData}) => {
    console.log("SENTIMENT DATA",sentimentData)
    console.log("PCR DATA",pcrData)
  return (
      <div>
    <div style={styles.container}>

      {/* ✅ Fear & Greed Gauge */}
      <div style={styles.chartBox}>
        <h3>Fear & Greed Index</h3>
        <Plot
          data={[
            {
              type: "indicator",
              mode: "gauge+number",
              value: sentimentData.fear_greed_score,
              title: { text: `Current Sentiment: ${sentimentData.sentiment}` },
              gauge: { axis: { range: [0, 100] }, steps: [{ range: [0, 30], color: "red" }, { range: [30, 70], color: "yellow" }, { range: [70, 100], color: "green" }] }
            }
          ]}
          layout={{ height: 500, width: 600 }}
        style={{ width: '100%', height: '100%' }}  // Full width/height of container
        />
      </div>
      {/*<div style={styles.chartBox}>*/}
      {/*  <h3>Insights:</h3>*/}
      {/*  <p><strong>0 - 20:</strong> Extreme Fear </p>*/}
      {/*  <p><strong>20 - 40:</strong>  Fear </p>*/}
      {/*  <p><strong>40 - 60:</strong> Neutral </p>*/}
      {/*  <p><strong>60 - 80:</strong> Greed </p>*/}
      {/*  <p><strong>60 - 80:</strong> Extreme Greed </p>*/}
      {/*</div>*/}
    </div>
    <div style={styles.container}>

       ✅ Put/Call Ratio
      <div style={styles.chartBox}>
        <h3>Put/Call Ratio</h3>
        <Plot
          data={[
            { x: pcrData.map(d => d.date), y: pcrData.map(d => d.pcr), type: "scatter", mode: "lines", name: "Put/Call Ratio", line: { color: "purple" } }
          ]}
          layout={{  height: 500, width: 700 , xaxis: { title: "Date" }, yaxis: { title: "PCR" } }}
        style={{ width: '100%', height: '100%' }}  // Full width/height of container
        />
      </div>
     </div>
    </div>
  );
}

const MarketVol = ({vixData,optionFlowData}) => {
        console.log("VIX DATA",vixData)
    // ✅ Prepare Treemap Data
  // const labels = optionFlowData.map((d) => `${d.symbol} | ${d.strike}`);
  const labels = optionFlowData.map((d) => Math.abs(d.oi_change) > 200000 ? `${d.strike}`:"");
  const parents = optionFlowData.map(() => ""); // Root-level treemap
  const values = optionFlowData.map((d) => Math.abs(d.oi_change) > 200000 ? Math.abs(d.oi_change):""); // Size by OI Change
  // const colors = optionFlowData.map((d) => Math.abs(d.oi_change) > 200000 ? (d.oi_change > 0 ? "green" : "red"):""); // Color Code
// ✅ Define Color Scale (Red → Yellow → Green)

  const oiChanges = optionFlowData.map((d) => d.oi_change);
  const maxOI = Math.max(...oiChanges);
  const minOI = Math.min(...oiChanges);
    const colors = oiChanges.map((oi) => {
      const normalized = (oi - minOI) / (maxOI - minOI); // Scale to [0, 1]
      const red = Math.round(255 * (1 - normalized));  // More negative → More Red
      const green = Math.round(255 * normalized);      // More positive → More Green
      return `rgb(${red}, ${green}, 0)`;
    });

  return (
    <div style={styles.container}>
      {/*<h2>Market Sentiment & Volatility</h2>*/}

       {/*✅ VIX Trend Line Chart*/}
      <div style={styles.chartBox}>
        <h3>✅ VIX and Index Movement Correlation </h3>
        <Plot
          data={[
            { x: vixData.map(d => d.date), y: vixData.map(d => d.vix), type: "scatter", mode: "lines", name: "VIX", line: { color: "blue" }, yaxis: "y1"}, // Attach to the first Y-axis},
            { x: vixData.map(d => d.date), y: vixData.map(d => d.index_change), type: "scatter", mode: "lines", name: "Index Performance", line: { color: "orange" }, yaxis : "y2" }
          ]}
          layout={{ height: 700, width: 1500, xaxis: { title: "Date" },
              yaxis: { title: "VIX" ,showgrid: false,
          zeroline: true,},
          yaxis2: {
          title: "Nifty Change",
          overlaying: "y",
          side: "right",
          showgrid: true,
          zeroline: true,
              // range: [-3, 3]
        },
          }}
        />
      </div>

      {/* ✅ Option Flow Heatmap */}
    <div style={styles.container}>
      <div style={styles.treemapBox}>
          <h3>✅ OI Change by Strike Price </h3>
        <Plot
          data={[
            {
              type: "treemap",
              labels: labels,
              parents: parents,
              values: values,
              marker: { colors: colors,
                         },
              textinfo: "label+value"
            }
          ]}
          layout={{ height: 700, width: 1200, title: "OI Heatmap" }}
        />
      </div>
    </div>
    </div>
  );
}

const MarketSentiment = () => {
  // const stockData = useContext(StockContext);
  // const [indices, setIndices] = useState([]);
  const subSections = ["Sentiment", "Market Volatility","OI Indicators"];
  const [data, setData] = useState(null);
  const [activeSubTab, setActiveSubTab] = useState(subSections[0]);

  const [sentimentData, setSentimentData] = useState(null);
  const [vixData, setVixData] = useState([]);
  const [pcrData, setPcrData] = useState([]);
  const [optionFlowData, setOptionFlowData] = useState([]);

  useEffect(() => {
    fetchMarketSentiment()
      .then(data => {
        setSentimentData(data.fear_greed_index[0]);
        setVixData(data.vix_data);
        setPcrData(data.put_call_ratio);
        setOptionFlowData(data.option_flow);
      });
      }, []);

  if (!sentimentData) return <p>Loading data...</p>;

  console.log("SUMMARY DATA  RECVD" , sentimentData);
  // if (!stockData) return <p>Loading stock data...</p>;

  const renderContent = () => {

    switch (activeSubTab) {
        case "Sentiment":
        return  sentimentData? (<div align={"center"}>
            <Sentiment sentimentData={sentimentData} pcrData={pcrData}/>
            </div>) : (
                <p>Loading Sentiment...</p>
              );
      case "Market Volatility":
        return  optionFlowData? (<div align={"center"}  style={{height:"700px"}}>
            <Stockchart symbol={"INDIA VIX"}/>
            </div>) : (
                <p>Loading data...</p>
              );
      case "OI Indicators":
        return  optionFlowData? (<div align={"center"}>
            <MarketVol optionFlowData={optionFlowData} vixData={vixData} />
            </div>) : (
                <p>Loading data...</p>
              );
      default:
        return <div>Select a tab to view content.</div>;
    }
  };

  return (
    <div className="section-container">
      {/* Vertical Sidebar */}
      <div className="sidebar">
        {subSections.map((tab) => (
          <button
            key={tab}
            className={`side-tab ${activeSubTab === tab ? "active" : ""}`}
            onClick={() => setActiveSubTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Content Display */}
      <div className="content">
        {/*<h2>{activeSubTab}</h2>*/}
        {/*<p>Displaying data for {activeSubTab}...</p>*/}
        {renderContent()}
      </div>
    </div>
  );
};

export default MarketSentiment;

// ✅ CSS-in-JS (Replacing Tailwind)
  // ✅ Styling
  const styles = {
    container: { padding: "16px", fontFamily: "Arial, sans-serif" },
    chartBox: { padding: "10px", border: "1px solid #ddd", borderRadius: "10px", backgroundColor: "white" },
    treemapBox: { padding: "10px", border: "1px solid #ddd", borderRadius: "10px", backgroundColor: "white" }
  };